import {UseMutationResult, useMutation} from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';

interface PublishClassroomTestPayload {
  meetingId: string;
  meetingRole: string;
}

export default function usePublishClassroomTestApi(
  handleOnSuccess?: (data: any) => void,
  handleOnError?: (error: unknown) => void,
): UseMutationResult<any, unknown, PublishClassroomTestPayload> {
  return useMutation<any, unknown, PublishClassroomTestPayload>(
    async (payload: PublishClassroomTestPayload) => {
      const response = await ChessRestClient.post(
        'classroom/v1/publish_classroom_test/',
        payload,
      );
      console.log('Publish classroom test = ', response.data);
      return response.data;
    },
    {
      onSuccess: (data: any) => {
        if (handleOnSuccess) {
          handleOnSuccess(data);
        }
      },
      onError: (error: unknown) => {
        console.error('Failed to publish classroom test:', error);
        if (handleOnError) {
          handleOnError(error);
        }
      },
    },
  );
}
